/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** The rating the caller already left for this participant at this event, if any. */
export enum UserRatingValue {
  LIKED = "LIKED",
  DISLIKED = "DISLIKED",
  NOT_SURE = "NOT_SURE",
}

/** The stage the simulated clock is set to, if any. */
export enum EventTestClockStage {
  GUEST_HINTS_REVEALED = "GUEST_HINTS_REVEALED",
  RESTAURANT_REVEALED = "RESTAURANT_REVEALED",
  CURATOR_CONTENT_REVEALED = "CURATOR_CONTENT_REVEALED",
  EVENT_STARTED = "EVENT_STARTED",
  AFTER_PARTY_REVEALED = "AFTER_PARTY_REVEALED",
  FEEDBACK_REQUESTED = "FEEDBACK_REQUESTED",
}

/** The feedback status of the reservation. */
export enum FeedbackStatus {
  NOT_READY = "NOT_READY",
  NOT_ELIGIBLE = "NOT_ELIGIBLE",
  NOT_SUBMITTED = "NOT_SUBMITTED",
  SUBMITTED = "SUBMITTED",
}

export interface QuestionExtraOptionsDto {
  /**
   * Unique ID of the option
   * @example 1
   */
  id: number;
  /**
   * The option display text
   * @example "Logic and facts"
   */
  displayText: string;
}

export interface QuestionExtraDto {
  /** List of options for select types */
  options?: QuestionExtraOptionsDto[];
  /**
   * Minimum value for range type
   * @example 1
   */
  min?: number;
  /**
   * Maximum value for range type
   * @example 10
   */
  max?: number;
  /**
   * Translation key for the minimum value label (range type)
   * @example "app:onboarding.answers.strongly_disagree"
   */
  minText?: string;
  /**
   * Translation key for the maximum value label (range type)
   * @example "app:onboarding.answers.strongly_agree"
   */
  maxText?: string;
}

export interface PersonalityQuestionDto {
  /**
   * Unique ID of the question
   * @example 101
   */
  id: number;
  /**
   * Unique slug for the question
   * @example "opinion-guided"
   */
  slug: string;
  /**
   * The question title
   * @example "Are your opinions guided by logic and facts?"
   */
  title: string;
  /**
   * The question subtitle
   * @example "This helps us understand your decision-making process."
   */
  subtitle?: string;
  /**
   * Type of the question determining frontend rendering
   * @example "select_single"
   */
  type:
    | "select_multiple"
    | "select_single"
    | "range"
    | "country"
    | "date"
    | "text"
    | "select_from_list";
  /**
   * Category grouping for the question
   * @example "personality"
   */
  category: string;
  /**
   * Indicates if the answer is read-only (e.g., pre-filled)
   * @example false
   */
  readOnly?: boolean;
  /** Extra details specific to the question type (options, range limits, etc.) */
  extra: QuestionExtraDto;
}

export interface PersonalityTestQuestionsDto {
  questions: PersonalityQuestionDto[];
}

export interface GetMySummaryResponseDto {
  /** The user's unique identifier. */
  uid: string;
  /** The user's email address. */
  email: string | null;
  /** The user's full name. */
  name: string | null;
  /** The user's nickname. */
  nickname?: string;
  /** The user's phone number. */
  phoneNumber: string;
  /** The user's gender. */
  gender?: string;
  /** The user's marital status. */
  maritalStatus?:
    | "SINGLE"
    | "MARRIED"
    | "RELATIONSHIP"
    | "COMPLICATED"
    | "NO_ANSWER";
  /** Whether the user has children. */
  hasChildren?: "YES" | "NO" | "NO_ANSWER";
  /** The user's profession. */
  profession?: string;
  /** The user's nationality. */
  nationality?: string;
  /**
   * The user's birth date.
   * @format date-time
   */
  birthDate?: string;
  /** The user's preference for group gender composition. */
  groupGenderPreference?: "ALL_GENDERS_OKAY" | "SAME_GENDER_PREFERRED";
  /** The user's preference for group age composition. */
  groupAgePreference?: "ALL_AGES_OKAY" | "SAME_AGE_PREFERRED";
  /**
   * The date and time the user was created.
   * @format date-time
   */
  createdAt: string;
  /** Whether the user has completed the personality test. */
  hasCompletedPersonalityTest: boolean | null;
  /** Whether the user has completed the signup flow. */
  hasCompletedSignupFlow: boolean;
}

export interface UpdateMyProfileRequestDto {
  /**
   * The user's full name.
   * @example "John Doe"
   */
  name?: string;
  /**
   * The user's nickname.
   * @example "Johnny"
   */
  nickname?: string;
  /**
   * The phone number to update the user profile with.
   * @pattern ^(\+82|0)?1[0-9]{8,9}$
   * @example "+82-10-9876-5432"
   */
  phoneNumber: string;
  /**
   * The user's gender.
   * @example "Male"
   */
  gender?: string;
  /** The user's marital status. */
  maritalStatus?:
    | "SINGLE"
    | "MARRIED"
    | "RELATIONSHIP"
    | "COMPLICATED"
    | "NO_ANSWER";
  /** Whether the user has children. */
  hasChildren?: "YES" | "NO" | "NO_ANSWER";
  /**
   * The user's profession.
   * @example "Software Engineer"
   */
  profession?: string;
  /**
   * The user's nationality.
   * @example "American"
   */
  nationality?: string;
  /**
   * The user's birth date in YYYY-MM-DD format.
   * @pattern ^\d{4}-\d{2}-\d{2}$
   * @example "1990-01-15"
   */
  birthDate?: string;
  /** The user's preference for group gender composition. */
  groupGenderPreference?: "ALL_GENDERS_OKAY" | "SAME_GENDER_PREFERRED";
  /** The user's preference for group age composition. */
  groupAgePreference?: "ALL_AGES_OKAY" | "SAME_AGE_PREFERRED";
}

export interface UserSummaryDto {
  /** The user's unique identifier. */
  uid: string;
  /** The user's email address. */
  email: string | null;
  /** The user's full name. */
  name: string | null;
  /** The user's nickname. */
  nickname?: string;
  /** The user's phone number. */
  phoneNumber: string;
  /** The user's gender. */
  gender?: string;
  /** The user's marital status. */
  maritalStatus?:
    | "SINGLE"
    | "MARRIED"
    | "RELATIONSHIP"
    | "COMPLICATED"
    | "NO_ANSWER";
  /** Whether the user has children. */
  hasChildren?: "YES" | "NO" | "NO_ANSWER";
  /** The user's profession. */
  profession?: string;
  /** The user's nationality. */
  nationality?: string;
  /**
   * The user's birth date.
   * @format date-time
   */
  birthDate?: string;
  /** The user's preference for group gender composition. */
  groupGenderPreference?: "ALL_GENDERS_OKAY" | "SAME_GENDER_PREFERRED";
  /** The user's preference for group age composition. */
  groupAgePreference?: "ALL_AGES_OKAY" | "SAME_AGE_PREFERRED";
  /**
   * The date and time the user was created.
   * @format date-time
   */
  createdAt: string;
  /** Whether the user has completed the personality test. */
  hasCompletedPersonalityTest: boolean | null;
  /** Whether the user has completed the signup flow. */
  hasCompletedSignupFlow: boolean;
}

export interface UtmDataDto {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;
}

export interface SignupUserWithEmailRequestDto {
  /**
   * User's unique email address
   * @example "john.doe@example.com"
   */
  email: string;
  /**
   * User's chosen nickname
   * @example "JohnnyD"
   */
  nickname: string;
  /**
   * User's password (at least 8 characters)
   * @example "Password123!"
   */
  password: string;
  /** PortOne identity verification ID from 본인인증 flow */
  identityVerificationId: string;
  /** UTM tracking data from marketing campaigns */
  utm?: UtmDataDto;
}

export interface SupabaseUserDto {
  /**
   * The unique identifier for the user.
   * @example "123e4567-e89b-12d3-a456-426614174000"
   */
  id: string;
  /**
   * The authentication provider ID.
   * @example "email"
   */
  aud: string;
  /**
   * The user role.
   * @example "authenticated"
   */
  role: string | null;
  /**
   * The user email address.
   * @example "user@example.com"
   */
  email: string | null;
  /**
   * Whether the email has been confirmed.
   * @example true
   */
  email_confirmed_at: string | null;
  /**
   * The phone number.
   * @example "+1234567890"
   */
  phone: string | null;
  /** When the phone was confirmed. */
  phone_confirmed_at: string | null;
  /**
   * When the user was created.
   * @example "2023-01-01T00:00:00.000Z"
   */
  created_at: string;
  /**
   * When the user was last updated.
   * @example "2023-01-01T00:00:00.000Z"
   */
  updated_at: string | null;
  /** User metadata. */
  user_metadata: object | null;
  /** App metadata. */
  app_metadata: object;
  /** User identities. */
  identities: any[] | null;
}

export interface SignupUserWithEmailResponseDto {
  /** JWT access token */
  access_token: string;
  /** JWT refresh token */
  refresh_token: string;
  /** Token expiry in seconds */
  expires_in: number;
  /** Token type, usually "bearer" */
  token_type: string;
  user: SupabaseUserDto;
}

export interface SignupUserWithKakaoRequestDto {
  /**
   * User's chosen nickname
   * @example "JohnnyD"
   */
  nickname: string;
  /** PortOne identity verification ID from 본인인증 flow */
  identityVerificationId: string;
  /**
   * User's gender
   * @example "Male"
   */
  gender?: string;
  /**
   * User's nationality
   * @example "American"
   */
  nationality?: string;
  /**
   * User's marital status
   * @example "SINGLE"
   */
  maritalStatus?:
    | "SINGLE"
    | "MARRIED"
    | "RELATIONSHIP"
    | "COMPLICATED"
    | "NO_ANSWER";
  /**
   * Does the user have children
   * @example "NO"
   */
  hasChildren?: "YES" | "NO" | "NO_ANSWER";
  /**
   * User's profession
   * @example "Software Engineer"
   */
  profession?: string;
  /** UTM tracking data from marketing campaigns */
  utm?: UtmDataDto;
}

export interface CheckDuplicateEmailRequestDto {
  /**
   * The email address to check for duplication.
   * @example "test@example.com"
   */
  email: string;
}

export interface ReservationQuestionOptionDto {
  /**
   * The unique value representing this option. Sent back to the backend when selected.
   * @example "123"
   */
  value: string;
  /**
   * The display text for the option shown to the user.
   * @example "용산/이태원"
   */
  displayText: string;
  /**
   * Custom input type for this option (e.g., text_input for OTHER options)
   * @example "text_input"
   */
  customInputType?: "text_input";
}

export interface ReservationQuestionDto {
  /**
   * Title of the question
   * @example "어디를 탐험하고 싶으신가요?"
   */
  title: string;
  /**
   * Subtitle of the question
   * @example "오프는 매주 새롭고 특별한..."
   */
  subtitle?: string;
  /**
   * Type of the question determining frontend rendering
   * @example "select_single"
   */
  type: "select_single" | "select_multiple" | "text";
  /**
   * Category grouping for the question (e.g., EVENT, DINNER)
   * @example "EVENT"
   */
  category: string;
  /**
   * Unique slug for the question
   * @example "where"
   */
  slug: string;
  /** List of options for select types */
  options?: ReservationQuestionOptionDto[];
}

export interface AvailableDateResponseDto {
  /**
   * The ISO string representation of the date
   * @example "2025-07-16T19:00:00.000Z"
   */
  value: string;
  /**
   * The display-friendly string for the date
   * @example "7월 16일 오후 7:00"
   */
  displayText: string;
}

export interface PersonalInfoInputDto {
  /**
   * User nationality
   * @example "South Korean"
   */
  nationality?: string;
  /**
   * Custom nationality text when "기타" is selected
   * @example "French Polynesia"
   */
  nationalityOtherText?: string;
  /**
   * Birthday of the user (YYYY-MM-DD)
   * @pattern ^\d{4}-\d{2}-\d{2}$
   * @example "1992-12-06"
   */
  birthDate?: string;
  /**
   * User gender
   * @example "Male"
   */
  gender?: string;
  /** User marital status */
  maritalStatus?:
    | "SINGLE"
    | "MARRIED"
    | "RELATIONSHIP"
    | "COMPLICATED"
    | "NO_ANSWER";
  /** Whether the user has children */
  hasChildren?: "YES" | "NO" | "NO_ANSWER";
  /**
   * User profession
   * @example "Software Engineer"
   */
  profession?: string;
  /** User preference for group gender composition */
  groupGenderPreference?: "ALL_GENDERS_OKAY" | "SAME_GENDER_PREFERRED";
  /** User preference for group age composition */
  groupAgePreference?: "ALL_AGES_OKAY" | "SAME_AGE_PREFERRED";
}

export interface SubmitMyProfileAndAnswersRequestDto {
  /** User's personal information */
  personal_info: PersonalInfoInputDto;
  /**
   * Object of answers, keyed by question ID
   * @example {"90":{"answerOptions":[1394]},"91":{"answerScale":4}}
   */
  answers: Record<string, any>;
}

export interface QuestionDetailsDto {
  /** The question's unique ID. */
  id: number;
  /** The question's unique slug. */
  slug: string;
  /** The title of the question. */
  title: string;
  /** The category of the question. */
  category: string;
  /** The type of question (e.g., RANGE, SINGLE_CHOICE). */
  questionType:
    | "RANGE"
    | "FREE_TEXT"
    | "MULTIPLE_CHOICE"
    | "SINGLE_CHOICE"
    | "COUNTRY"
    | "DATE"
    | "SELECT_FROM_LIST";
}

export interface SelectedOptionDetailsDto {
  /** The option's unique ID. */
  id: number;
  /** The text for the option. */
  displayText: string;
  /** The value associated with the option. */
  value?: string;
}

export interface SelectedOptionContainerDto {
  option: SelectedOptionDetailsDto;
}

export interface GetMyPersonalityTestAnswersDto {
  /** The answer's unique ID. */
  id: number;
  /** The ID of the question this answer is for. */
  questionId: number;
  /** The free-text answer, if any. */
  answerText?: string;
  /** The scale-based answer, if any. */
  answerScale?: number;
  question: QuestionDetailsDto;
  /** The options selected for a multiple-choice question. */
  selectedOptions: SelectedOptionContainerDto[];
}

export type ValidateMagicLinkTokenRequestDto = object;

export type ExchangeMagicLinkTokenRequestDto = object;

export interface ReservationEventLocationDto {
  /** The unique identifier for the location. */
  id: number;
  /** The location of the event. */
  name: string;
}

export interface ReservationEventDetailsDto {
  /**
   * The actual event start time if an event is associated with the reservation.
   * @format date-time
   */
  startTime: string;
  /** The location of the event. */
  location: ReservationEventLocationDto;
}

export interface GetMyUpcomingReservationsResponseDto {
  /** The unique identifier for the reservation. */
  id: number;
  /** The ID of the user who made the reservation. */
  userId: string;
  /** Array of preferred location names for the reservation. */
  preferredLocationNames: string[];
  /** Array of preferred dates and times for the reservation. */
  preferredTimes: string[];
  /** A message from the reserving user for other guests. */
  messageForGuests?: string;
  /** User preferred language for the dinner. */
  preferredLanguage?: "KOREAN" | "ENGLISH" | "BOTH";
  /** User preferred cost range for the dinner. */
  preferredCost?: "LOW" | "MEDIUM" | "HIGH";
  /** Array of dietary restriction slugs applicable to the user. */
  dietaryRestrictionSlugs: (
    | "NONE"
    | "VEGAN"
    | "VEGETARIAN"
    | "GLUTEN_FREE"
    | "OTHER"
  )[];
  /** Additional text for OTHER dietary restriction option. */
  dietaryRestrictionsOtherText?: string;
  /**
   * The date and time the reservation was created.
   * @format date-time
   */
  createdAt: string;
  /**
   * The date and time the reservation was last updated.
   * @format date-time
   */
  updatedAt: string;
  /** The event identifier for the reservation. */
  eventId?: number;
  /** The attendance status of the reservation. */
  attendanceStatus?: "ON_TIME" | "LATE" | "NO_SHOW" | "CANCELLED";
  /** The status of the reservation. */
  status:
    | "PENDING"
    | "CONFIRMED"
    | "CHANGE_REQUESTED_BY_ADMIN"
    | "PREFERENCE_OVERRIDE_REQUESTED"
    | "CANCELLED"
    | "CANCELLED_NO_REFUND";
  /** The category of cancellation if the reservation was cancelled. */
  cancellationCategory?:
    | "USER_REQUESTED"
    | "USER_DECLINED_CHANGE"
    | "ADMIN_CANCELLED"
    | "SYSTEM_CANCELLED"
    | "EVENT_EXPIRED";
  /** The actual event start time if an event is associated with the reservation. */
  event?: ReservationEventDetailsDto;
  /** The new event requested by admin when status is CHANGE_REQUESTED_BY_ADMIN. This represents the event the admin wants to move the user to. */
  newEventRequested?: ReservationEventDetailsDto;
  /** The feedback status of the reservation. */
  feedbackStatus: FeedbackStatus;
}

export interface ReservationDetailsInputDto {
  /**
   * Array of preferred location IDs for the reservation.
   * @example [1,2]
   */
  preferredLocationIds: number[];
  /**
   * Array of user's preferred dates and times for the reservation (ISO 8601 format).
   * @example ["2025-07-15T19:00:00.000Z","2025-07-16T19:00:00.000Z"]
   */
  preferredTimes: string[];
  /**
   * A message from the reserving user for other guests.
   * @example "Looking forward to meeting everyone!"
   */
  messageForGuests?: string;
}

export interface DinnerPreferenceInputDto {
  /**
   * User preferred language for the dinner.
   * @example "ENGLISH"
   */
  preferredLanguage: "KOREAN" | "ENGLISH" | "BOTH";
  /**
   * User preferred cost range for the dinner.
   * @example "MEDIUM"
   */
  preferredCost: "LOW" | "MEDIUM" | "HIGH";
  /**
   * Array of dietary restriction enums applicable to the user.
   * @example ["VEGAN","GLUTEN_FREE"]
   */
  dietaryRestrictions: (
    | "NONE"
    | "VEGAN"
    | "VEGETARIAN"
    | "GLUTEN_FREE"
    | "OTHER"
  )[];
  /**
   * Custom text for dietary restrictions when OTHER is selected.
   * @example "Allergic to shellfish"
   */
  dietaryRestrictionsOtherText?: string;
}

export interface CreateReservationRequestRequestDto {
  /** Details for the reservation location and time. */
  reservationDetails: ReservationDetailsInputDto;
  /** User preferences for the dinner. */
  dinnerPreference: DinnerPreferenceInputDto;
  /**
   * Payment ID from PortOne
   * @example "payment-20260811-xxxxxxxx"
   */
  paymentId: string;
  /**
   * Payment amount in KRW
   * @example 15000
   */
  amount: number;
}

export interface RequestReservationResponseDto {
  /**
   * Array of preferred dates and times for the reservation.
   * @example ["2025-07-21T19:00:00.000Z","2025-07-22T19:00:00.000Z"]
   */
  preferredTimes: string[];
  /**
   * Array of preferred location names for the reservation.
   * @example ["Seoul Station","Gangnam Station"]
   */
  preferredLocationNames: string[];
}

export interface ConfirmReservationRequestDto {
  /**
   * The ID of the reservation to confirm.
   * @example 1
   */
  reservationId: number;
}

export interface UpdateAttendanceStatusRequestDto {
  /**
   * The attendance status of the reservation
   * @example "ON_TIME"
   */
  attendanceStatus: "ON_TIME" | "LATE" | "NO_SHOW" | "CANCELLED";
}

export interface CancelReservationRequestBodyDto {
  /**
   * Reason for cancelling the reservation.
   * @example "Unable to attend due to personal reasons"
   */
  cancellationReason?: string;
}

export interface CancelReservationResponseDto {
  /**
   * Success message indicating the reservation was cancelled.
   * @example "Reservation cancelled successfully"
   */
  message: string;
  /**
   * The ID of the cancelled reservation request.
   * @example 1
   */
  reservationRequestId: number;
  /**
   * The status of the refund.
   * @example "REFUNDED"
   */
  refundStatus: string;
}

export interface GetPaymentConfigurationResponseDto {
  storeId: string;
  channelKey: string;
  itemCode: string;
}

export interface CreateRefundRequestDto {
  /**
   * ID of the reservation request to create refund for
   * @example 1
   */
  reservationRequestId: number;
  /**
   * Optional reason for the refund
   * @example "Customer requested cancellation"
   */
  reason?: string;
}

export interface CreateRefundResponseDto {
  /**
   * Unique identifier for the payment
   * @example 1
   */
  id: number;
  /**
   * Current status of the payment
   * @example "PENDING"
   */
  status: "PENDING" | "PAID" | "REFUNDED";
  /**
   * Type of payment
   * @example "PAYMENT"
   */
  type: "PAYMENT" | "REFUND";
  /**
   * ID of the associated reservation request
   * @example 1
   */
  reservationRequestId: number;
  /**
   * When the payment was created
   * @format date-time
   * @example "2024-01-01T00:00:00.000Z"
   */
  createdAt: string;
  /**
   * When the payment was last updated
   * @format date-time
   * @example "2024-01-01T00:00:00.000Z"
   */
  updatedAt: string;
  /**
   * Success message for refund creation
   * @example "Refund created successfully"
   */
  message: string;
}

export interface GetPaymentResponseDto {
  /**
   * Unique identifier for the payment
   * @example 1
   */
  id: number;
  /**
   * Current status of the payment
   * @example "PENDING"
   */
  status: "PENDING" | "PAID" | "REFUNDED";
  /**
   * Type of payment
   * @example "PAYMENT"
   */
  type: "PAYMENT" | "REFUND";
  /**
   * ID of the associated reservation request
   * @example 1
   */
  reservationRequestId: number;
  /**
   * When the payment was created
   * @format date-time
   * @example "2024-01-01T00:00:00.000Z"
   */
  createdAt: string;
  /**
   * When the payment was last updated
   * @format date-time
   * @example "2024-01-01T00:00:00.000Z"
   */
  updatedAt: string;
  /**
   * Additional metadata for payment retrieval
   * @example "Payment retrieved successfully"
   */
  metadata: string;
}

export interface GetPaymentsByReservationResponseDto {
  /**
   * Unique identifier for the payment
   * @example 1
   */
  id: number;
  /**
   * Current status of the payment
   * @example "PENDING"
   */
  status: "PENDING" | "PAID" | "REFUNDED";
  /**
   * Type of payment
   * @example "PAYMENT"
   */
  type: "PAYMENT" | "REFUND";
  /**
   * ID of the associated reservation request
   * @example 1
   */
  reservationRequestId: number;
  /**
   * When the payment was created
   * @format date-time
   * @example "2024-01-01T00:00:00.000Z"
   */
  createdAt: string;
  /**
   * When the payment was last updated
   * @format date-time
   * @example "2024-01-01T00:00:00.000Z"
   */
  updatedAt: string;
  /**
   * Reservation context for the payments
   * @example "Payments for reservation #123"
   */
  reservationContext: string;
}

export interface VenueInfoDto {
  /**
   * The name of the venue.
   * @example "Burger King"
   */
  name: string | null;
  /**
   * The address of the venue.
   * @example "123 Main St, Anytown, USA"
   */
  address: string | null;
}

export interface ProfessionDistributionDto {
  /**
   * The profession
   * @example "Software Engineer"
   */
  profession: string;
  /**
   * The percentage of guests with this profession
   * @example 25.5
   */
  percentage: number;
}

export interface NationalityDistributionDto {
  /**
   * The nationality
   * @example "American"
   */
  nationality: string;
  /**
   * The percentage of guests with this nationality
   * @example 50
   */
  percentage: number;
}

export interface GetEventResponseDto {
  /** Restaurant information for the event. */
  restaurant: VenueInfoDto;
  /** After-party venue information for the event. */
  afterPartyVenue: VenueInfoDto;
  /**
   * A message from the event curator.
   * @example "Welcome to our special event!"
   */
  curatorMessage: string | null;
  /**
   * The curator's icebreaker game.
   * @example "Two Truths and a Lie"
   */
  talkingPointsCardLink: string | null;
  /**
   * A list of messages from guests.
   * @example ["Looking forward to meeting everyone!","Excited for the night."]
   */
  guestMessages: string[] | null;
  /** Distribution of guest professions. */
  professionDistribution: ProfessionDistributionDto[] | null;
  /** Distribution of guest nationalities. */
  nationalityDistribution: NationalityDistributionDto[] | null;
  /**
   * The start time of the event.
   * @format date-time
   * @example "2025-07-21T19:00:00.000Z"
   */
  startTime: string;
  /** The feedback status of the reservation. */
  feedbackStatus: FeedbackStatus;
}

export interface CreateEventVenueRequestDto {
  /**
   * The name of the venue
   * @example "강남 이탈리안 레스토랑"
   */
  name: string;
  /**
   * The address of the venue
   * @example "서울시 강남구 테헤란로 123"
   */
  address: string;
  /**
   * The ID of the location this venue belongs to
   * @example 1
   */
  locationId?: number;
  /**
   * The type of venue
   * @example "RESTAURANT"
   */
  type: "RESTAURANT" | "AFTER_PARTY";
}

export interface EventVenueResponseDto {
  /**
   * The unique ID of the venue
   * @example 1
   */
  id: number;
  /**
   * The name of the venue
   * @example "강남 이탈리안 레스토랑"
   */
  name: string;
  /**
   * The address of the venue
   * @example "서울시 강남구 테헤란로 123"
   */
  address: string;
  /**
   * The ID of the location this venue belongs to
   * @example 1
   */
  locationId?: number;
  /**
   * The name of the location this venue belongs to
   * @example "강남"
   */
  locationName?: string;
  /**
   * The type of venue
   * @example "RESTAURANT"
   */
  type: "RESTAURANT" | "AFTER_PARTY";
  /**
   * Number of events held at this venue
   * @example 12
   */
  eventCount: number;
  /**
   * Number of feedback reviews left for this venue
   * @example 30
   */
  reviewCount: number;
  /**
   * Average score (1-5) across all reviews, null if no reviews
   * @example 4.2
   */
  avgScore?: number;
}

export interface UpdateEventVenueRequestDto {
  /**
   * The name of the venue
   * @example "강남 이탈리안 레스토랑"
   */
  name?: string;
  /**
   * The address of the venue
   * @example "서울시 강남구 테헤란로 123"
   */
  address?: string;
  /**
   * The ID of the location this venue belongs to
   * @example 1
   */
  locationId?: number;
  /**
   * The type of venue
   * @example "RESTAURANT"
   */
  type?: "RESTAURANT" | "AFTER_PARTY";
}

export interface CreateFeedbackRequestDto {
  /**
   * The ID of the event for which feedback is being provided.
   * @example 1
   */
  eventId: number;
  /**
   * Group compatibility score (1-5).
   * @min 1
   * @max 5
   * @example 4
   */
  groupCompatibilityScore: number;
  /**
   * Restaurant score (1-5).
   * @min 1
   * @max 5
   * @example 5
   */
  restaurantScore: number;
  /**
   * After location score (1-5).
   * @min 1
   * @max 5
   * @example 3
   */
  afterLocationScore: number;
  /**
   * Recommendation to friend score (1-5).
   * @min 1
   * @max 5
   * @example 4
   */
  recommendationToFriendScore: number;
  /**
   * Whether the user would attend again.
   * @example true
   */
  wouldReAttend: boolean;
  /**
   * Optional open feedback text.
   * @example "Great experience overall, would love to see more variety in restaurants."
   */
  openFeedback?: string;
}

export interface UserTestSettingsDto {
  testPaymentEnabled: boolean;
}

export interface AdminUserDto {
  uid: string;
  email: string;
  name?: string | null;
  nickname?: string | null;
  isTestUser: boolean;
  testSettings: UserTestSettingsDto;
}

export interface SearchUsersResponseDto {
  users: AdminUserDto[];
}

export interface UpdateUserTestSettingsRequestDto {
  testPaymentEnabled: boolean;
}

export interface PreferredLocationDto {
  id: number;
  name: string;
}

export interface UserDto {
  uid: string;
  name: string;
  nickname: string;
  isTestUser: boolean;
  /** @format date-time */
  birthDate: string;
  gender: string;
  nationality: string;
  profession: string;
  groupGenderPreference?: "ALL_GENDERS_OKAY" | "SAME_GENDER_PREFERRED";
  groupAgePreference?: "ALL_AGES_OKAY" | "SAME_AGE_PREFERRED";
  personalityTestAnswers: GetMyPersonalityTestAnswersDto[];
}

export interface ReservationRequestDto {
  id: number;
  preferredTimes: string[];
  preferredLocations: PreferredLocationDto[];
  messageForGuests: string;
  preferredLanguage: "KOREAN" | "ENGLISH" | "BOTH";
  preferredCost: "LOW" | "MEDIUM" | "HIGH";
  dietaryRestrictionSlugs: (
    | "NONE"
    | "VEGAN"
    | "VEGETARIAN"
    | "GLUTEN_FREE"
    | "OTHER"
  )[];
  dietaryRestrictionsOtherText?: string;
  status:
    | "PENDING"
    | "CONFIRMED"
    | "CHANGE_REQUESTED_BY_ADMIN"
    | "PREFERENCE_OVERRIDE_REQUESTED"
    | "CANCELLED"
    | "CANCELLED_NO_REFUND";
  cancellationCategory?:
    | "USER_REQUESTED"
    | "USER_DECLINED_CHANGE"
    | "ADMIN_CANCELLED"
    | "SYSTEM_CANCELLED"
    | "EVENT_EXPIRED";
  user: UserDto;
  /** @format date-time */
  createdAt: string;
}

export interface GetReservationRequestsResponseDto {
  reservationRequests: ReservationRequestDto[];
}

export interface GroupMetadataDto {
  size: number;
  genderRatio: {
    male?: number;
    female?: number;
  };
  ageRange: {
    min?: number;
    max?: number;
  };
  locationIds: number[];
  locationNames: string[];
  occupations: string[];
  commonTimeSlots: string[];
  score: number;
}

export interface SuggestedGroupDto {
  id: string;
  requests: ReservationRequestDto[];
  metadata: GroupMetadataDto;
}

export interface AutoGroupReservationRequestsResponseDto {
  suggestedGroups: SuggestedGroupDto[];
  ungroupedRequests: ReservationRequestDto[];
}

export interface LocationDto {
  id: number;
  name: string;
}

export interface GetLocationsResponseDto {
  locations: LocationDto[];
}

export interface EventTestClockDto {
  /** Whether the event is a test event that can run on a simulated clock. */
  isTest: boolean;
  /**
   * The moment all time gates for this event treat as "now". Null means real time.
   * @format date-time
   */
  simulatedNow: string | null;
  /** The stage the simulated clock is set to, if any. */
  stage: EventTestClockStage | null;
}

export interface EventDto {
  id: number;
  /** @format date-time */
  startTime: string;
  capacity: number;
  locationName: string;
  /** @format date-time */
  createdAt: string;
  reservationRequests: ReservationRequestDto[];
  restaurantId?: number;
  afterPartyVenueId?: number;
  testClock: EventTestClockDto;
}

export interface GetEventsResponseDto {
  events: EventDto[];
}

export interface CreateEventFromReservationsRequestDto {
  /**
   * The start time of the event.
   * @format date-time
   * @example "2025-08-01T19:00:00.000Z"
   */
  startTime: string;
  /**
   * The capacity of the event.
   * @example 8
   */
  capacity: number;
  /**
   * An array of reservation request IDs to be included in the event.
   * @example [1,5,12]
   */
  reservationRequestIds: number[];
  /**
   * The ID of the location where the event will be held.
   * @example 1
   */
  locationId: number;
  /**
   * The ID of the restaurant venue for the event.
   * @example 1
   */
  restaurantId?: number;
  /**
   * The ID of the after party venue for the event.
   * @example 2
   */
  afterPartyVenueId?: number;
}

export type Event = object;

export interface RequestReservationChangeDto {
  /**
   * The ID of the new event to move the user to
   * @example 42
   */
  newEventId: number;
}

export interface UpdateEventRequestDto {
  /**
   * Array of reservation request IDs to add to the event.
   * @example [1,2,3]
   */
  reservationRequestIds?: number[];
  /**
   * ID of the restaurant venue for this event
   * @example 1
   */
  restaurantId?: number;
  /**
   * ID of the after-party venue for this event
   * @example 2
   */
  afterPartyVenueId?: number;
}

export interface UpdateEventTestModeRequestDto {
  /** Marks the event as a test event. Turning this off also resets the simulated clock to real time. */
  isTest: boolean;
}

export interface SetEventTestClockRequestDto {
  /** The stage to jump the simulated clock to. Null resets the event to real time. */
  stage: EventTestClockStage | null;
}

export interface SetEventTestClockResponseDto {
  /** Whether the event is a test event that can run on a simulated clock. */
  isTest: boolean;
  /**
   * The moment all time gates for this event treat as "now". Null means real time.
   * @format date-time
   */
  simulatedNow: string | null;
  /** The stage the simulated clock is set to, if any. */
  stage: EventTestClockStage | null;
  /** How many queued SMS messages were sent immediately because the simulated clock passed their scheduled time. */
  releasedNotificationCount: number;
}

export interface UserEventHistoryItemDto {
  /** @example 1 */
  eventId: number;
  /** @format date-time */
  eventDate: string;
  /** @example "트라토리아 서울" */
  restaurantName?: string;
  /** @example "이태원 칵테일바" */
  afterPartyName?: string;
  /** @example 4 */
  restaurantScore?: number;
  /** @example 3 */
  afterLocationScore?: number;
  paymentStatus?: "PENDING" | "PAID" | "REFUNDED";
  attendanceStatus?: "ON_TIME" | "LATE" | "NO_SHOW" | "CANCELLED";
}

export interface GetUserEventHistoryResponseDto {
  history: UserEventHistoryItemDto[];
}

export interface UserRatingEdgeDto {
  /** @example "uid-1" */
  raterId: string;
  /** @example "uid-2" */
  ratedUserId: string;
  value: "LIKED" | "DISLIKED" | "NOT_SURE";
}

export interface GetUserRatingEdgesResponseDto {
  ratings: UserRatingEdgeDto[];
}

export interface AdminUserRatingItemDto {
  /** @example 1 */
  eventId: number;
  /** @format date-time */
  eventStartTime: string;
  /** @example "uid-2" */
  counterpartUserId: string;
  /** @example "민준" */
  counterpartDisplayName: string;
  value: "LIKED" | "DISLIKED" | "NOT_SURE";
  /** @format date-time */
  ratedAt: string;
}

export interface GetUserRatingsResponseDto {
  /** 이 유저가 다른 유저에게 남긴 평가 */
  given: AdminUserRatingItemDto[];
  /** 이 유저가 다른 유저에게 받은 평가 */
  received: AdminUserRatingItemDto[];
}

export interface AdminCancelAndRefundReservationResponseDto {
  /**
   * Success message indicating the reservation was cancelled.
   * @example "Reservation cancelled successfully"
   */
  message: string;
  /**
   * The ID of the cancelled reservation request.
   * @example 1
   */
  reservationRequestId: number;
  /**
   * The status of the refund.
   * @example "REFUNDED"
   */
  refundStatus: string;
}

export interface RateableParticipantDto {
  /**
   * The uid of the participant that can be rated.
   * @example "a1b2c3d4-e5f6-7890-abcd-ef1234567890"
   */
  userId: string;
  /**
   * The name to show for this participant. Falls back to their name, then to a generic label.
   * @example "느긋한 티라미슈"
   */
  displayName: string;
  /** The rating the caller already left for this participant at this event, if any. */
  myRating: UserRatingValue | null;
  /**
   * When the caller left their rating, if they have left one.
   * @format date-time
   * @example "2025-07-21T14:00:00.000Z"
   */
  ratedAt: string | null;
}

export interface GetRateableParticipantsResponseDto {
  /**
   * Whether the rating window for this event has opened.
   * @example true
   */
  isRatingOpen: boolean;
  /** The other attendees of the event, excluding the caller. */
  participants: RateableParticipantDto[];
}

export interface CreateUserRatingRequestDto {
  /**
   * The ID of the event both users attended.
   * @example 1
   */
  eventId: number;
  /**
   * The uid of the user being rated.
   * @example "a1b2c3d4-e5f6-7890-abcd-ef1234567890"
   */
  ratedUserId: string;
  /**
   * The rating left about the other user.
   * @example "LIKED"
   */
  value: UserRatingValue;
}

export interface UserRatingInputDto {
  /**
   * The uid of the user being rated.
   * @example "a1b2c3d4-e5f6-7890-abcd-ef1234567890"
   */
  ratedUserId: string;
  /**
   * The rating left about the other user.
   * @example "LIKED"
   */
  value: UserRatingValue;
}

export interface CreateUserRatingsRequestDto {
  /**
   * The ID of the event all rated users attended.
   * @example 1
   */
  eventId: number;
  /** One entry per co-attendee being rated. */
  ratings: UserRatingInputDto[];
}

export interface GenerateTestUsersRequestDto {
  /**
   * How many test users to create.
   * @min 1
   * @max 100
   * @example 30
   */
  count: number;
}

export interface GenerateTestUsersResponseDto {
  createdUserCount: number;
  createdReservationRequestCount: number;
  /** Test users that could not be created. Each failure is rolled back and reported to telemetry. */
  failedUserCount: number;
}

export interface DeleteTestDataResponseDto {
  deletedUserCount: number;
  /** Events deleted because every attendee was a test user. Events with real attendees are kept. */
  deletedEventCount: number;
  /** Supabase auth accounts that could not be deleted. Their app data is already gone, so they can no longer be used. */
  failedAuthUserDeletionCount: number;
}
